module.exports = __webpack_public_path__ + "img/file.66ad565b.svg";